module.exports = __webpack_public_path__ + "static/img/reward-bg.a0204985.png";